import { useCallback, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { openBlob } from "@/lib/blob";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ReportVersions } from "@/components/ReportVersions";
import { toast } from "sonner";
import * as Icons from "lucide-react";

export function VisitReportCard({ visit }) {
  const [rep, setRep] = useState(undefined);
  const load = useCallback(() => api.get("/visit-reports", { params: { visit_id: visit.id } }).then((r) => setRep(r.data[0] || null)).catch(() => setRep(null)), [visit.id]);
  useEffect(() => { load(); }, [load]);
  const create = async () => { try { await api.post("/visit-reports/from-visit", { visit_id: visit.id }); load(); } catch (e) { toast.error(apiError(e)); } };
  return (
    <Card className="p-4 lg:p-5" data-testid="visit-report-card">
      <h2 className="mb-2 flex items-center gap-2 font-display text-base font-semibold text-slate-800"><Icons.FileStack className="h-5 w-5 text-emerald-600" />Rapport client versionné</h2>
      {visit.imported_from_pdf && rep?.has_source && (
        <Button size="sm" variant="outline" className="mb-3" onClick={() => openBlob(`/visit-reports/${rep.id}/versions/1/pdf`)} data-testid="visit-source-pdf"><Icons.FileSearch className="mr-1.5 h-4 w-4" />Voir le PDF d'origine (interne)</Button>)}
      {rep === undefined ? <div className="h-16 animate-pulse rounded bg-slate-100" />
        : rep ? <ReportVersions reportId={rep.id} />
        : <div className="flex flex-wrap items-center justify-between gap-2 text-sm text-slate-500"><span>Gérez des versions publiables (associables à plusieurs devis).</span>
            <Button size="sm" variant="outline" onClick={create} data-testid="visit-report-create">Activer les versions client</Button></div>}
    </Card>
  );
}
